import { PledgeTransactionTypeEnum } from '@tassat/common-definitions';
import { PledgeRecord } from '@tassat/fred-definitions';

import {
    DEFAULT_INITIAL_STATE,
    ModalPledgeValues,
    PledgeContextWorkflowState,
    PledgeModalAction,
    PledgeTransactionRow
} from './pledgeContextWorkflowContext';
import { ModalScreen } from '../pledgeDetailsModal';

export type PledgeContextWorkflowAction =
    | {
        type: 'CHANGE_MODAL_SCREEN';
        payload: {
            screen: ModalScreen;
        };
    } |
    {
        type: 'SET_PLEDGE_ACTION_IN_PROGRESS';
        payload: boolean;
    } |
    {
        type: 'SET_ACCOUNT_ID';
        payload: string;
    } |
    {
        type: 'SET_PLEDGE_TYPE';
        payload: PledgeTransactionTypeEnum;
    } |
    {
        type: 'SET_MODAL_PLEDGE_VALUES';
        payload: ModalPledgeValues;
    } |
    {
        type: 'SET_SELECTED_PLEDGE_TRANSACTION';
        payload: PledgeTransactionRow;
    } |
    {
        type: 'SET_SELECTED_PLEDGE';
        payload: PledgeRecord;
    } |
    {
        type: 'SET_MODAL_ACTION';
        payload: PledgeModalAction | null;
    } |
    { type: 'RESET' };

export const PledgeContextWorkflowReducer = (
    state: PledgeContextWorkflowState,
    action: PledgeContextWorkflowAction
): PledgeContextWorkflowState => {
    switch (action.type) {
        case 'CHANGE_MODAL_SCREEN':
            return {
                ...state,
                modalScreen: action.payload.screen
            };
        case 'SET_PLEDGE_ACTION_IN_PROGRESS':
            return {
                ...state,
                pledgeActionInProgress: action.payload
            };
        case 'SET_ACCOUNT_ID':
            return {
                ...state,
                accountId: action.payload
            };
        case 'SET_PLEDGE_TYPE':
            return {
                ...state,
                pledgeType: action.payload
            };
        case 'SET_MODAL_PLEDGE_VALUES':
            return {
                ...state,
                modalPledgeValues: action.payload
            };
        case 'SET_SELECTED_PLEDGE_TRANSACTION':
            return {
                ...state,
                selectedPledgeTransaction: action.payload
            };
        case 'SET_SELECTED_PLEDGE':
            return {
                ...state,
                selectedPledge: action.payload
            };
        case 'SET_MODAL_ACTION':
            return {
                ...state,
                modalAction: action.payload
            };
        case 'RESET':
            return { ...DEFAULT_INITIAL_STATE };
        default:
            return state;
    }
};